import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SimpleSelectOptionDto } from 'src/shared/services/api.service';

@Component({
  selector: 'cert-pd-verification-request-modal',
  standalone: false,
  templateUrl: './pd-verification-request-modal.component.html',
  styles: ``,
})
export class PdVerificationRequestModalComponent implements OnInit {
  @Input() isRejection!: boolean;
  @Input() professionalDevelopmentTypeOptions: SimpleSelectOptionDto[] = [];

  selectedProfessionalDevelopmentTypeCodeId: number | undefined;
  rejectionDetails = '';

  constructor(private readonly activeModal: NgbActiveModal) {}

  ngOnInit() {
    if (!this.isRejection && this.professionalDevelopmentTypeOptions.length === 1) {
      this.selectedProfessionalDevelopmentTypeCodeId = this.professionalDevelopmentTypeOptions[0].id;
    }
  }

  confirm() {
    this.activeModal.close({
      professionalDevelopmentTypeCodeId: this.selectedProfessionalDevelopmentTypeCodeId ?? null,
      rejectionDetails: this.rejectionDetails || null,
    });
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
